// import React from "react";
// import {
//   Target,
//   Rocket,
//   Heart,
//   Globe,
//   Shield,
//   Cloud,
//   Smartphone,
//   Brain,
//   Eye,
//   Flag,
//   Database,
//   Lock,
//   HeadphonesIcon,
//   Zap,
// } from "lucide-react";
// import D2 from "../assets/about.jpeg";
// import { Helmet } from "react-helmet-async";


// const AboutUsPage = () => {
//   const values = [
//     {
//       icon: <Target className="w-8 h-8" />,
//       title: "Customer First",
//       description:
//         "We prioritize our customers' success above everything else.",
//       color: "from-blue-500 to-cyan-500",
//     },
//     {
//       icon: <Rocket className="w-8 h-8" />,
//       title: "Innovation",
//       description: "Constantly evolving to provide cutting-edge solutions.",
//       color: "from-purple-500 to-pink-500",
//     },
//     {
//       icon: <Shield className="w-8 h-8" />,
//       title: "Trust & Security",
//       description: "Your data security is our topmost priority.",
//       color: "from-green-500 to-emerald-500",
//     },
//     {
//       icon: <Heart className="w-8 h-8" />,
//       title: "Passion",
//       description: "We love what we do and it shows in our work.",
//       color: "from-orange-500 to-red-500",
//     },
//   ];

//   const services = [
//     {
//       icon: <Brain className="w-10 h-10" />,
//       title: "AI Lead Scoring",
//       description: "Intelligent algorithms to prioritize your best leads",
//       stats: "98% Accuracy",
//     },
//     {
//       icon: <Cloud className="w-10 h-10" />,
//       title: "Cloud Integration",
//       description: "Seamless integration with your existing tools",
//       stats: "50+ Integrations",
//     },
//     {
//       icon: <Database className="w-10 h-10" />,
//       title: "Data Analytics",
//       description: "Deep insights into your lead generation performance",
//       stats: "Real-time Reports",
//     },
//     {
//       icon: <Lock className="w-10 h-10" />,
//       title: "Secure Platform",
//       description: "Enterprise-grade security for your data",
//       stats: "Bank-level Encryption",
//     },
//     {
//       icon: <HeadphonesIcon className="w-10 h-10" />,
//       title: "24/7 Support",
//       description: "Round-the-clock assistance for your team",
//       stats: "< 5min Response",
//     },
//     {
//       icon: <Smartphone className="w-10 h-10" />,
//       title: "Mobile Ready",
//       description: "Manage leads anytime, anywhere",
//       stats: "100% Responsive",
//     },
//   ];

//   return (
//     <>
//       <Helmet>
//         {/* Primary SEO */}
//         <title>About LMSBots | Lead Management & CRM Software</title>
//         <meta
//           name="description"
//           content="Learn about LMSBots – a smart lead management and CRM software helping businesses automate follow-ups, track leads, and increase sales conversions."
//         />
//         <meta
//           name="keywords"
//           content="about LMSBots, CRM software company, lead management system, sales automation tools, AI lead tracking"
//         />
//         <meta name="robots" content="index, follow" />
//         {/* Canonical */}
//         <link rel="canonical" href="https://lmsbots.com/about-us" />
//         {/* Open Graph */}
//         <meta
//           property="og:title"
//           content="About LMSBots - Smart Lead Management Platform"
//         />
//         <meta
//           property="og:description"
//           content="Discover how LMSBots helps businesses automate lead tracking, improve conversions, and scale faster with smart CRM tools."
//         />
//         <meta property="og:url" content="https://lmsbots.com/about-us" />
//         <meta property="og:type" content="website" />
//         <meta property="og:image" content="https://lmsbots.com/logo512.png" />
//         {/* Twitter */}
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:title" content="About LMSBots CRM Platform" />
//         <meta
//           name="twitter:description"
//           content="Explore LMSBots - a powerful lead management and automation platform for modern businesses."
//         />
//         <meta name="twitter:image" content="https://lmsbots.com/logo512.png" />
//       </Helmet>

//       {/* your existing JSX starts here */}
//       <div className="min-h-[50vh] pt-10 lg:pt-16">
//         {/* Hero Section with Gradient Text */}

//         <section className="relative bg-[#0B1220] text-white overflow-hidden">
//           {/* Soft Gradient Glow Background */}
//           <div className="absolute inset-0">
//             <div className="absolute top-[-100px] left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-gradient-to-r from-blue-600/30 via-indigo-500/20 to-purple-600/30 blur-3xl rounded-full"></div>
//           </div>

//           {/* Subtle Grid */}
//           <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff10_1px,transparent_1px),linear-gradient(to_bottom,#ffffff10_1px,transparent_1px)] bg-[size:40px_40px] opacity-20"></div>

//           <div className="relative max-w-6xl mx-auto px-6 py-20 text-center">
//             {/* Badge */}
//             <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 px-4 py-2 rounded-full mb-6 backdrop-blur-md">
//               <Zap className="w-4 h-4 text-yellow-400" />
//               <span className="text-xs tracking-wide text-blue-200">
//                 Smart Lead Automation Platform
//               </span>
//             </div>

//             {/* Heading */}
//             <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
//               About{" "}
//               <span className="bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
//                 LMSBOTS
//               </span>
//             </h1>

//             {/* Subtext */}
//             <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-10">
//               Automate follow-ups, capture every lead, and convert faster with
//               an intelligent system built for modern sales teams.
//             </p>

//             {/* CTA Buttons */}
//             {/* <div className="flex flex-col sm:flex-row justify-center gap-4">
//       <button className="px-6 py-3 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 transition font-medium shadow-lg shadow-blue-900/30">
//         Get Started
//       </button>

//       <button className="px-6 py-3 rounded-lg border border-white/20 hover:bg-white/5 transition font-medium">
//         See How It Works
//       </button>
//     </div> */}
//           </div>

//           {/* Clean Wave Divider */}
//           <div className="absolute bottom-0 left-0 right-0">
//             <svg
//               className="w-full h-28 text-white"
//               viewBox="0 0 1440 100"
//               preserveAspectRatio="none"
//             >
//               <path
//                 fill="currentColor"
//                 d="M0,50 C300,100 1100,0 1440,50 L1440,100 L0,100 Z"
//               ></path>
//             </svg>
//           </div>
//         </section>

//         {/* About LMSBOTS Section - White Background with Image */}
//         <section className="bg-white py-20">
//           <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//             <div className="grid lg:grid-cols-2 gap-12 items-center">
//               {/* Left Content */}
//               <div>
//                 <span className="text-blue-600 font-semibold text-sm   ca  bg-blue-50 px-4 py-2 rounded-full">
//                   About LMSBOTS
//                 </span>
//                 <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-6 mb-6">
//                   Leading the Future of{" "}
//                   <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
//                     Lead Management
//                   </span>
//                 </h2>

//                 <div className="space-y-4 text-gray-600">
//                   <p className="text-base leading-relaxed">
//                     <span className="font-semibold text-gray-900 text-base">
//                       LMSBOTS Pvt. Ltd.
//                     </span>{" "}
//                     is a leading software company at the forefront of
//                     technological innovation. Since 2020, we've been committed
//                     to delivering cutting-edge software solutions that empower
//                     businesses to thrive in the digital era.
//                   </p>

//                   <p className="text-base leading-relaxed">
//                     Our team of 50+ experts specializes in developing innovative
//                     software solutions, implementing robust cybersecurity
//                     measures, and providing top-notch IT support to ensure your
//                     business stays ahead in today's digital landscape.
//                   </p>
//                 </div>
//               </div>

//               {/* Right side - Image with Stats Overlay */}
//               <div className="relative">
//                 {/* Main Image Container */}
//                 <div className="relative rounded-2xl overflow-hidden shadow-2xl">
//                   <img
//                     src={D2}
//                     alt="LMSBOTS Team Working"
//                     className="w-full h-auto object-cover"
//                   />

//                   {/* Gradient Overlay */}
//                   <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/20 to-purple-600/20"></div>
//                 </div>

//                 {/* Decorative Elements */}
//                 <div className="absolute -z-10 -top-4 -right-4 w-72 h-72 bg-blue-200 rounded-full opacity-20 blur-3xl"></div>
//                 <div className="absolute -z-10 -bottom-4 -left-4 w-72 h-72 bg-purple-200 rounded-full opacity-20 blur-3xl"></div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* What We Do Section - Light Blue Background */}
//         <section className="bg-[linear-gradient(to_bottom_right,#f8fbff,#eef5ff)] py-5">
//           <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//             <div className="text-center mt-3 mb-3">
//               <span className="text-blue-600 font-medium text-sm   bg-blue-100 px-4 py-1 rounded-full">
//                 Our Expertise
//               </span>
//               <h2 className="text-4xl md:text-4xl font-bold mt-2 mb-2">
//                 <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
//                   What We Do
//                 </span>
//               </h2>

//               <p className="text-base text-gray-600 max-w-3xl mx-auto">
//                 Comprehensive lead management solutions tailored for your
//                 business growth
//               </p>

//               <div className="w-40 h-[3px] bg-blue-600 mx-auto mt-1 rounded"></div>
//             </div>

//             <div className="grid md:grid-cols-2 lg:grid-cols-3 mt-2 gap-6">
//               {services.map((service, index) => (
//                 <div
//                   key={index}
//                   className="group relative bg-white rounded-xl p-5 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden"
//                 >
//                   {/* Hover Background */}
//                   <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

//                   {/* Decorative Circle */}
//                   <div className="absolute -right-8 -top-8 w-24 h-24 bg-blue-100 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>

//                   {/* Content */}
//                   <div className="relative z-10">
//                     <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg text-white flex items-center justify-center mb-4 group-hover:scale-110 transition">
//                       {service.icon}
//                     </div>

//                     <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-white transition-colors">
//                       {service.title}
//                     </h3>

//                     <p className="text-sm text-gray-600 group-hover:text-white/90 mb-3 leading-relaxed">
//                       {service.description}
//                     </p>

//                     <div className="text-xs font-semibold text-blue-600 group-hover:text-white/80">
//                       {service.stats}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* Mission & Vision Cards - White Background */}
//         <section className="bg-white py-10">
//           <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//             <div className="text-center mb-8">
//               <span className="text-blue-600 font-semibold text-sm    bg-blue-50 px-4 py-2 rounded-full">
//                 Our Purpose
//               </span>
//               <h2 className="text-4xl md:text-4xl font-semibold text-gray-900 mt-3">
//                 Mission &{" "}
//                 <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
//                   Vision
//                 </span>
//               </h2>
//             </div>

//             <div className="grid md:grid-cols-2 gap-8">
//               {/* Mission Card */}
//               <div className="group relative bg-gradient-to-br from-gray-50 to-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden">
//                 <div className="absolute top-0 right-0 w-40 h-40 bg-blue-100 rounded-full -mr-16 -mt-16 group-hover:scale-[12] transition-transform duration-700 ease-in-out opacity-50"></div>

//                 <div className="relative z-10">
//                   <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl text-white flex items-center justify-center mb-8 group-hover:scale-110 group-hover:rotate-12 transition-all duration-300">
//                     <Flag className="w-8 h-8" />
//                   </div>

//                   <h3 className="text-3xl font-semibold text-gray-900 mb-3">
//                     Our Mission
//                   </h3>

//                   <p className="text-gray-600 leading-relaxed text-base mb-4">
//                     To empower businesses of all sizes with intelligent tools
//                     that transform lead management from a challenge into a
//                     competitive advantage. We believe in making enterprise-grade
//                     technology accessible to everyone.
//                   </p>

//                   <div className="flex items-center space-x-4 text-blue-600 bg-blue-50 px-4 py-2 rounded-full w-fit">
//                     <Target className="w-4 h-4" />
//                     <span className="font-medium">
//                       Empower • Enable • Excel
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               {/* Vision Card */}
//               <div className="group relative bg-gradient-to-br from-blue-600 to-purple-600 rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden">
//                 <div className="absolute top-0 right-0 w-40 h-40 bg-white/20 rounded-full -mr-16 -mt-16 group-hover:scale-[12] transition-transform duration-700 ease-in-out"></div>

//                 <div className="relative z-10">
//                   <div className="w-14 h-14 bg-white/20 backdrop-blur-lg rounded-2xl text-white flex items-center justify-center mb-8 group-hover:scale-110 group-hover:rotate-12 transition-all duration-300">
//                     <Eye className="w-8 h-8" />
//                   </div>

//                   <h3 className="text-3xl font-semibold text-white mb-2">
//                     Our Vision
//                   </h3>

//                   <p className="text-blue-100 leading-relaxed text-base mb-4">
//                     To create a world where no lead goes unnoticed, no
//                     opportunity is missed, and every business can build
//                     meaningful relationships with their customers through smart,
//                     automated lead management solutions.
//                   </p>

//                   <div className="flex items-center space-x-4 text-white bg-white/20 backdrop-blur-lg px-4 py-2 rounded-full w-fit">
//                     <Globe className="w-4 h-4" />
//                     <span className="font-medium">
//                       Global • Innovative • Impactful
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Values Section - Light Blue Background */}
//         <section className="bg-[linear-gradient(to_bottom_right,#f8fbff,#eef5ff)] py-10">
//           <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//             <div className="text-center mb-10">
//               <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider bg-blue-100 px-4 py-2 rounded-full">
//                 Our Values
//               </span>
//               <h2 className="text-4xl md:text-4xl font-bold text-gray-900 mt-3 mb-2">
//                 What Drives Us Forward
//               </h2>
//               <p className="text-base text-gray-600 max-w-2xl mx-auto">
//                 These core principles guide every decision we make and every
//                 feature we build.
//               </p>
//             </div>

//             <div className="grid md:grid-cols-4 gap-6">
//               {values.map((value, index) => (
//                 <div
//                   key={index}
//                   className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden"
//                 >
//                   {/* Gradient Border on Hover */}
//                   <div
//                     className={`absolute inset-0 bg-gradient-to-r ${value.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}
//                   ></div>

//                   <div className="relative z-10">
//                     <div
//                       className={`w-14 h-14 bg-gradient-to-r ${value.color} rounded-xl text-white flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300`}
//                     >
//                       {value.icon}
//                     </div>

//                     <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-white transition-colors duration-300">
//                       {value.title}
//                     </h3>

//                     <p className="text-gray-600 group-hover:text-white/90 transition-colors duration-300">
//                       {value.description}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default AboutUsPage;








import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import {
  Target,
  Rocket,
  Heart,
  Globe,
  Shield,
  Cloud,
  Smartphone,
  Brain,
  Eye,
  Flag,
  Database,
  Lock,
  Headphones,
  Zap,
  Sparkles,
  ArrowRight,
  Users,
  Award,
} from "lucide-react";
import D2 from "../assets/about.jpeg";
import { Link } from "react-router-dom";
import Seo, { SITE_URL } from "../WebsiteComponents/Seo";
import { ROUTES, organizationSchema } from "../seoData";

const PATH = "/about-us";
const TITLE = ROUTES[PATH].title;
const DESCRIPTION = ROUTES[PATH].description;

const VALUES = [
  {
    icon: Target,
    title: "Customer first",
    description: "Our customers' success drives every decision we make.",
    tint: "from-[#12dfbd] to-[#0f9d86]",
  },
  {
    icon: Rocket,
    title: "Innovation",
    description: "We ship, learn, and evolve — constantly.",
    tint: "from-[#702cb0] to-[#48247f]",
  },
  {
    icon: Shield,
    title: "Trust & security",
    description: "Your data is protected with enterprise-grade security.",
    tint: "from-[#3b3a89] to-[#5c58b8]",
  },
  {
    icon: Heart,
    title: "Passion",
    description: "We love what we do, and it shows in the product.",
    tint: "from-[#ef6f6c] to-[#c94a47]",
  },
];

const SERVICES = [
  {
    icon: Brain,
    title: "AI lead scoring",
    description: "Intelligent ranking surfaces the leads most likely to convert.",
    stat: "98% accuracy",
  },
  {
    icon: Cloud,
    title: "Cloud integrations",
    description: "Connect the tools your team already relies on.",
    stat: "50+ integrations",
  },
  {
    icon: Database,
    title: "Data analytics",
    description: "Real-time dashboards for pipeline, sources, and agent performance.",
    stat: "Live reports",
  },
  {
    icon: Lock,
    title: "Secure platform",
    description: "Role-based access, audit logs, and encrypted data at rest.",
    stat: "Bank-level encryption",
  },
  {
    icon: Headphones,
    title: "24/7 support",
    description: "Fast, human help whenever your team needs it.",
    stat: "< 5 min response",
  },
  {
    icon: Smartphone,
    title: "Mobile ready",
    description: "Manage leads, calls, and follow-ups on the go.",
    stat: "100% responsive",
  },
];

const HERO_POINTS = ["50+ team members", "Since 2020", "Trusted by growing teams"];

const JSON_LD = [
  organizationSchema({ numberOfEmployees: { "@type": "QuantitativeValue", value: 50 } }),
  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "@id": `${SITE_URL}${PATH}#aboutpage`,
    url: `${SITE_URL}${PATH}`,
    name: TITLE,
    description: DESCRIPTION,
    inLanguage: "en-IN",
    isPartOf: { "@id": `${SITE_URL}/#website` },
    about: { "@id": `${SITE_URL}/#organization` },
    primaryImageOfPage: { "@type": "ImageObject", url: `${SITE_URL}/og-image.png` },
    breadcrumb: { "@id": `${SITE_URL}${PATH}#breadcrumb` },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": `${SITE_URL}${PATH}#breadcrumb`,
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: "About us", item: `${SITE_URL}${PATH}` },
    ],
  },
];

const SectionHeading = ({ id, pill, icon: Icon, before, highlight, after, text }) => (
  <div className="mx-auto mb-10 max-w-3xl text-center lg:mb-14">
    <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-[11px] font-medium text-[#48247f] shadow-sm sm:text-xs">
      {Icon ? <Icon className="h-3.5 w-3.5 text-[#702cb0]" /> : <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#12dfbd]" />}
      {pill}
    </div>
    <h2
      id={id}
      className="text-balance text-[24px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[30px] md:text-[34px] lg:text-[38px]"
    >
      {before}{" "}
      <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
        {highlight}
      </span>
      {after ? ` ${after}` : ""}
    </h2>
    {text && (
      <p className="mx-auto mt-4 max-w-[640px] text-sm leading-[1.75] text-[#3b2a63] sm:text-[15px] md:text-base">
        {text}
      </p>
    )}
    <div className="mx-auto mt-6 h-1 w-24 rounded-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f]" />
  </div>
);

const AboutUsPage = () => {
  const reduced = useReducedMotion();
  const fade = reduced ? undefined : { opacity: 0, y: 24 };
  const fadeIn = reduced
    ? undefined
    : {
        hidden: { opacity: 0, y: 24 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
      };
  const stagger = reduced
    ? undefined
    : { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.1 } } };
  const initial = reduced ? false : "hidden";

  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />

      <div
        className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased"
      >
        {/* ================= HERO — same hero palette, new light-surface treatment ================= */}
        <section
          aria-labelledby="about-heading"
          className="relative isolate w-full overflow-hidden bg-gradient-to-b from-[#f6f3fc] via-white to-white"
        >
          <div
            className="pointer-events-none absolute inset-0 -z-10 opacity-40"
            style={{
              backgroundImage: "radial-gradient(#48247f18 1px, transparent 1px)",
              backgroundSize: "22px 22px",
              WebkitMaskImage: "radial-gradient(ellipse at 40% 40%, black 30%, transparent 80%)",
              maskImage: "radial-gradient(ellipse at 40% 40%, black 30%, transparent 80%)",
            }}
          />
          <div className="pointer-events-none absolute -right-24 -top-24 -z-10 h-72 w-72 rounded-full bg-[#702cb0]/10 blur-3xl sm:h-96 sm:w-96" />
          <div className="pointer-events-none absolute -left-24 bottom-0 -z-10 h-64 w-64 rounded-full bg-[#12dfbd]/12 blur-3xl sm:h-80 sm:w-80" />

          <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-20 sm:gap-12 sm:px-8 sm:pb-16 sm:pt-24 md:px-10 lg:grid-cols-[1.05fr_1fr] lg:gap-14 lg:px-14 lg:pb-24 lg:pt-32 xl:px-20">
            <motion.div
              initial={initial}
              animate="visible"
              variants={stagger}
              className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
            >
              <motion.div variants={fadeIn}>
                <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-[11px] font-medium text-[#48247f] shadow-sm sm:mb-6 sm:text-xs">
                  <Sparkles className="h-3.5 w-3.5 text-[#702cb0]" />
                  Smart lead automation platform
                </div>
              </motion.div>

              <motion.h1
                id="about-heading"
                variants={fadeIn}
                className="text-balance text-[26px] font-light leading-[1.2] tracking-tight sm:text-[32px] md:text-[36px] lg:text-[40px] xl:text-[44px]"
              >
                Building the future of{" "}
                <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                  lead management
                </span>
              </motion.h1>

              <motion.p
                variants={fadeIn}
                className="mx-auto mt-4 max-w-[560px] text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base lg:mx-0 lg:text-[17px]"
              >
                LMSBOTS helps modern sales teams capture every lead, automate
                follow-ups, and close faster — with a CRM built around how teams
                actually work.
              </motion.p>

              <motion.div
                variants={fadeIn}
                className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
              >
                <Link
                  to="/contact"
                  className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Talk to our team
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
                <Link
                  to="/features"
                  className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-6 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Explore features
                </Link>
              </motion.div>

              <motion.ul
                variants={fadeIn}
                className="mt-8 flex flex-wrap items-center justify-center gap-x-4 gap-y-2.5 sm:gap-x-5 lg:justify-start"
              >
                {HERO_POINTS.map((p) => (
                  <li
                    key={p}
                    className="inline-flex items-center gap-2 text-[11px] font-medium text-[#3b2a63] sm:text-xs md:text-sm"
                  >
                    <Zap className="h-3.5 w-3.5 text-[#0f9d86]" strokeWidth={2.4} />
                    {p}
                  </li>
                ))}
              </motion.ul>
            </motion.div>

            <motion.div
              initial={reduced ? false : { opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none"
            >
              <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#e3faf5]" />
              <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
                <img
                  src={D2}
                  alt="LMSBOTS team collaborating on the lead management platform"
                  width="1200"
                  height="800"
                  fetchPriority="high"
                  decoding="async"
                  className="h-auto w-full rounded-xl border border-slate-200 object-cover"
                />
              </div>
            </motion.div>
          </div>
        </section>

        {/* ================= ABOUT / STORY ================= */}
        <section
          aria-labelledby="story-heading"
          className="relative w-full bg-white py-12 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-8 md:px-10 lg:px-14">
            <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
              <motion.div
                initial={initial}
                whileInView="visible"
                viewport={{ once: true, margin: "-80px" }}
                variants={stagger}
              >
                <motion.div variants={fadeIn}>
                  <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-[11px] font-medium text-[#48247f] shadow-sm sm:text-xs">
                    <Users className="h-3.5 w-3.5 text-[#702cb0]" />
                    About LMSBOTS
                  </div>
                </motion.div>
                <motion.h2
                  id="story-heading"
                  variants={fadeIn}
                  className="text-balance text-[24px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[30px] md:text-[34px] lg:text-[38px]"
                >
                  A software company{" "}
                  <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                    built for the digital era
                  </span>
                </motion.h2>

                <motion.div
                  variants={fadeIn}
                  className="mt-6 space-y-4 text-sm leading-[1.8] text-[#3b2a63] sm:text-[15px] md:text-base"
                >
                  <p>
                    <span className="font-medium text-[#28194f]">LMSBOTS Pvt. Ltd.</span>{" "}
                    is a software company focused on lead management and CRM.
                    Since 2020, we've been building tools that help teams replace
                    spreadsheets and scattered follow-ups with a single, clear
                    pipeline.
                  </p>
                  <p>
                    Our team of 50+ engineers, designers, and support specialists
                    work alongside customers to make enterprise-grade lead
                    management accessible — without the enterprise complexity.
                  </p>
                </motion.div>

                <motion.div
                  variants={fadeIn}
                  className="mt-8 grid grid-cols-3 gap-4 border-t border-[#48247f]/10 pt-6"
                >
                  {[
                    { value: "50+", label: "Team members" },
                    { value: "2020", label: "Founded" },
                    { value: "10k+", label: "Leads daily" },
                  ].map((s) => (
                    <div key={s.label}>
                      <div className="text-xl font-light tracking-tight text-[#28194f] sm:text-2xl">
                        {s.value}
                      </div>
                      <div className="mt-1 text-[11px] font-medium uppercase tracking-wider text-[#702cb0]/70 sm:text-xs">
                        {s.label}
                      </div>
                    </div>
                  ))}
                </motion.div>
              </motion.div>

              <motion.div
                initial={reduced ? false : { opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, ease: "easeOut" }}
                className="relative mx-auto w-full max-w-[560px]"
              >
                <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#f1ecfa]" />
                <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
                  <img
                    src={D2}
                    alt="LMSBOTS team working together on CRM features"
                    width="1200"
                    height="800"
                    loading="lazy"
                    decoding="async"
                    className="h-auto w-full rounded-xl border border-slate-200 object-cover"
                  />
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* ================= WHAT WE DO ================= */}
        <section
          aria-labelledby="services-heading"
          className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-12 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -right-24 -top-24 -z-10 h-72 w-72 rounded-full bg-[#702cb0]/10 blur-3xl sm:h-96 sm:w-96" />
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-8 md:px-10 lg:px-14">
            <SectionHeading
              id="services-heading"
              pill="Our expertise"
              icon={Sparkles}
              before="What we"
              highlight="do"
              text="Comprehensive lead management tools, built to help your team capture, nurture, and convert with confidence."
            />

            <motion.ul
              variants={stagger}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
            >
              {SERVICES.map((s) => {
                const Icon = s.icon;
                return (
                  <motion.li
                    key={s.title}
                    variants={fadeIn}
                    className="group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white p-6 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.22)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.35)] sm:p-7"
                  >
                    <div className="absolute left-0 top-0 h-1 w-full origin-left scale-x-0 bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-x-100" />

                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white">
                      <Icon className="h-6 w-6" />
                    </div>

                    <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">
                      {s.title}
                    </h3>
                    <p className="text-sm leading-[1.7] text-slate-700">
                      {s.description}
                    </p>
                    <div className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-[#e3faf5] px-2.5 py-1 text-[11px] font-semibold text-[#0f9d86]">
                      <Award className="h-3 w-3" />
                      {s.stat}
                    </div>
                  </motion.li>
                );
              })}
            </motion.ul>
          </div>
        </section>

        {/* ================= MISSION & VISION ================= */}
        <section
          aria-labelledby="mission-heading"
          className="relative w-full bg-white py-12 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-8 md:px-10 lg:px-14">
            <SectionHeading
              id="mission-heading"
              pill="Our purpose"
              icon={Target}
              before="Mission &"
              highlight="vision"
              text="Two commitments that shape every product decision we make."
            />

            <div className="grid gap-6 md:grid-cols-2 md:gap-8">
              {/* Mission */}
              <motion.article
                initial={reduced ? false : { opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.55 }}
                className="group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white p-6 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.22)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.35)] sm:p-8 lg:p-10"
              >
                <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#f1ecfa] opacity-70" />
                <div className="relative">
                  <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-[#48247f] to-[#702cb0] text-white shadow-md shadow-[#48247f]/25">
                    <Flag className="h-5 w-5" />
                  </div>
                  <h3 className="text-xl font-medium tracking-tight text-[#28194f] sm:text-2xl">
                    Our mission
                  </h3>
                  <p className="mt-3 text-sm leading-[1.8] text-[#3b2a63] sm:text-[15px]">
                    To give businesses of every size intelligent tools that turn
                    lead management from a headache into a competitive
                    advantage. Enterprise-grade technology should be accessible
                    to everyone.
                  </p>
                  <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#e3faf5] px-3 py-1.5 text-[11px] font-semibold text-[#0f9d86] sm:text-xs">
                    <Target className="h-3.5 w-3.5" />
                    Empower · Enable · Excel
                  </div>
                </div>
              </motion.article>

              {/* Vision */}
              <motion.article
                initial={reduced ? false : { opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.55, delay: 0.08 }}
                className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#48247f] via-[#5a2a94] to-[#702cb0] p-6 text-white shadow-[0_24px_60px_-24px_rgba(72,36,127,0.55)] sm:p-8 lg:p-10"
              >
                <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-white/10" />
                <div className="relative">
                  <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-white/15 text-white backdrop-blur">
                    <Eye className="h-5 w-5" />
                  </div>
                  <h3 className="text-xl font-medium tracking-tight sm:text-2xl">Our vision</h3>
                  <p className="mt-3 text-sm leading-[1.8] text-white/85 sm:text-[15px]">
                    A world where no lead goes unnoticed, no opportunity is
                    missed, and every business can build meaningful
                    relationships with their customers through smart automation.
                  </p>
                  <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1.5 text-[11px] font-semibold text-white backdrop-blur sm:text-xs">
                    <Globe className="h-3.5 w-3.5" />
                    Global · Innovative · Impactful
                  </div>
                </div>
              </motion.article>
            </div>
          </div>
        </section>

        {/* ================= VALUES ================= */}
        <section
          aria-labelledby="values-heading"
          className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-12 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -bottom-24 -left-24 -z-10 h-72 w-72 rounded-full bg-[#12dfbd]/15 blur-3xl sm:h-96 sm:w-96" />
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-8 md:px-10 lg:px-14">
            <SectionHeading
              id="values-heading"
              pill="Our values"
              icon={Heart}
              before="What"
              highlight="drives us forward"
              text="Core principles that shape every decision we make and every feature we ship."
            />

            <motion.ul
              variants={stagger}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
            >
              {VALUES.map((v) => {
                const Icon = v.icon;
                return (
                  <motion.li
                    key={v.title}
                    variants={fadeIn}
                    className="group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white p-6 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.22)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.35)]"
                  >
                    <div className="absolute left-0 top-0 h-1 w-full origin-left scale-x-0 bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-x-100" />

                    <div
                      className={`mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br ${v.tint} text-white shadow-md`}
                    >
                      <Icon className="h-5 w-5" />
                    </div>

                    <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">
                      {v.title}
                    </h3>
                    <p className="text-sm leading-[1.7] text-slate-700">
                      {v.description}
                    </p>
                  </motion.li>
                );
              })}
            </motion.ul>
          </div>
        </section>

        {/* ================= CLOSING CTA ================= */}
        <section
          aria-labelledby="about-cta-heading"
          className="w-full bg-white px-4 pb-10 pt-2 sm:px-10 sm:pb-12 lg:px-14 lg:pb-16"
        >
          <div className="relative isolate mx-auto w-full max-w-[1300px] overflow-hidden rounded-[1.5rem] border border-[#48247f]/10 bg-gradient-to-br from-[#f1ecfa] via-white to-[#e3faf5] px-5 py-12 text-center shadow-[0_20px_60px_-20px_rgba(72,36,127,0.25)] sm:rounded-[2rem] sm:px-12 sm:py-16">
            <div className="pointer-events-none absolute -left-20 -top-20 -z-10 h-72 w-72 rounded-full bg-[#702cb0]/10 blur-3xl" />
            <h2
              id="about-cta-heading"
              className="mx-auto max-w-2xl text-balance text-[24px] font-light leading-[1.25] tracking-tight sm:text-[30px] md:text-[34px]"
            >
              Want to see{" "}
              <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                LMSBOTS in action?
              </span>
            </h2>
            <p className="mx-auto mt-4 max-w-[560px] text-sm leading-[1.75] text-[#3b2a63] sm:text-[15px] md:text-base">
              Book a demo and we'll walk through lead capture, routing,
              automation, and reporting — tailored to how your team works today.
            </p>
            <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
              <Link
                to="/contact"
                className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-7 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
              >
                Book a demo
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <Link
                to="/pricing"
                className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-7 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
              >
                View pricing
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUsPage;